import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NextStepsComponent } from './next-steps.component';
import { NextStepsModule } from '@EYN/components/goals';

@NgModule({
	declarations: [NextStepsComponent],
	exports: [NextStepsComponent],
	imports: [
		CommonModule,
		NextStepsModule,
	]
})
export class NextStepsPageModule {
}
